export default "__VITE_ASSET__DFHLobgf__"